import Vue from 'vue';
import Vuex from 'vuex'
import App from './App.vue';
import $ from 'jquery';
import router from './router';
import dataV from '@jiaminghi/data-view';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
	Message
} from 'element-ui';
Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(Vuex);

Vue.component(Message.name, Message);
Vue.prototype.$message = Message;

import {
	Button,
	Select,
	Carousel,
	Input,
	DatePicker,
	Form,
	FormItem,
	Radio,
	Dialog,
} from 'element-ui';
Vue.use(Button);
Vue.use(Select);
Vue.use(Carousel);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(Dialog);

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/sort-up.js';
import 'vue-awesome/icons/sort-down.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

// 全局注册图标
Vue.component('icon', Icon);

// 适配flex
import '@/common/flexible.js';

// 引入全局css
import './assets/scss/style.scss';


import * as store from './store';

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');

import axios from './http';
Vue.prototype.$axios = axios

router.beforeEach(function (to, from, next) {
  // store.commit('clearToken') // 取消请求
  next()
})
